runResolvers